import './src/vaadin-split-layout.js';
export * from './src/vaadin-split-layout.js';
